import { Editor } from "@tiptap/core"
import { TextAlign as TextAlignExtension } from "@tiptap/extension-text-align"
import { UndoRedo } from "@tiptap/extensions"
import { useEditorState } from "@tiptap/react"

import { TextAlign } from "../enums"
import { useExtensionManagerWarning } from "./editor"

export const useTextAlignState = (editor: Editor) => {
	useExtensionManagerWarning(TextAlignExtension.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				textAlign: (editor.getAttributes(editor.state.selection.$anchor.node().type.name)[
					TextAlignExtension.name
				] ?? TextAlign.LEFT) as TextAlign,
				isActive: (alignment: TextAlign) =>
					editor?.isActive({
						[TextAlignExtension.name]: alignment,
					}),
				canToggle: (alignment: TextAlign) => editor.can().toggleTextAlign(alignment),
				canSet: (alignment: TextAlign) => editor.can().setTextAlign(alignment),
				canUnset: editor.can().unsetTextAlign(),
			}
		},
	})
}

export const useUndoRedoState = (editor: Editor) => {
	useExtensionManagerWarning(UndoRedo.name, editor)
	return useEditorState({
		editor,
		selector: () => {
			return {
				canUndo: editor.can().undo(),
				canRedo: editor.can().redo(),
			}
		},
	})
}
